import React from 'react';
import Section from '~components/layout/section';

interface IInfomeetingFormSuccess {
  section: any;
}

const InfomeetingFormSuccess = (props: IInfomeetingFormSuccess) => {
  return (
    <Section {...props.section} />
  )
}

export default InfomeetingFormSuccess;
